
function TimeDiff(props) {
    return (
        <p className="mb-0 text-muted"> { timeDiff(props.startdate) } </p>
    )
    
}
function timeDiff(startdate) {
    var subAddDays, thisDay;
    var start = new Date(startdate * 1000);
    var end = new Date();
    var diff = end -  start;
    //Create numbers for dividing to get hour, minute and second diff
    var units = [
    1000 * 60 * 60 *24,
    1000 * 60 * 60,
    1000 * 60,
    1000
    ];

    var rv = []; // h, m, s array
    //loop through d, h, m, s. we are not gonna use days, its just there to subtract it from the time
    for (var i = 0; i < units.length; ++i) {
        rv.push(Math.floor(diff / units[i]));
        diff = diff % units[i];
    }

    //Get the year of this year
    var thisFullYear = end.getFullYear();
    //Check how many days there where in last month
    var daysInLastMonth = new Date(thisFullYear, end.getMonth(), 0).getDate();
    //Get this month
    var thisMonth = end.getMonth(); 
    //Subtract to get differense between years
    thisFullYear = thisFullYear - start.getFullYear();
    //Subtract to get differense between months
    thisMonth = thisMonth - start.getMonth();
    //If month is less than 0 it means that we are some moths before the start date in the year.
    // So we subtract one year, and add the negative number (month) to 12. (12 + -1 = 11)
    subAddDays = daysInLastMonth - start.getDate();
    thisDay = end.getDate();
    thisMonth = thisMonth - 1;
    if(thisMonth < 0){
        thisFullYear = thisFullYear - 1;
        thisMonth = 12 + thisMonth;
        //Get ends day of the month
    }
    //Subtract the start date from the number of days in the last month, add add the result to todays day of the month
    subAddDays = daysInLastMonth - start.getDate();
    subAddDays = thisDay + subAddDays;

    
    if(subAddDays >= daysInLastMonth){
        subAddDays = subAddDays - daysInLastMonth;
        thisMonth++;
        if (thisMonth > 11){
            thisFullYear++;
            thisMonth = 0;
        }
    }

    var sReturn = "";
    if (thisFullYear > 0) {
        if (thisFullYear > 1) {
            sReturn = thisFullYear + " years ago.";
        } else {
            sReturn = thisFullYear + " year ago.";
        }
    } else if (thisMonth > 0) {
        if (thisMonth > 1) {
            sReturn = thisMonth + " months ago.";
        } else {
            sReturn = thisMonth + " month ago.";
        }
    } else if (subAddDays > 0) {
        if (subAddDays > 1) {
            sReturn = subAddDays + " days ago.";
        } else {
            sReturn = subAddDays + " day ago.";
        }
    } else if (rv[1] > 0) {
        if (rv[1] > 1) {
            sReturn = rv[1] + " hours ago.";
        } else {
            sReturn = rv[1] + " hour ago.";
        }
    } else if (rv[2] > 0) {
        if (rv[2] > 1) {
            sReturn = rv[2] + " minutes ago.";
        } else {
            sReturn = rv[2] + " minute ago.";
        }
    } else if (rv[3] > 15) {
        sReturn = rv[3] + " seconds ago.";
    } else {
        sReturn = "Just Now.";
    }

    return sReturn;
}

export default TimeDiff